import type { EventHoldInput, EventInput } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type EventGroupInput = {
  eventGroupId?: number;
  /**
   * Passthrough: AppSchema's `EventInput` is already the right shape with every field optional,
   * matching what the Add-Hold modal builds, so a domain mirror would map nothing. Note this
   * drops the legacy per-event `take()` whitelist: since callers pass a variable rather than a
   * fresh literal, TS excess-property checking won't flag a stray key, so a future extra field
   * would be rejected server-side instead of silently dropped.
   */
  events: EventInput[];
};

export const toGqlInput = (input: EventGroupInput): EventHoldInput =>
  take(input, 'eventGroupId', 'events');
